import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getVideos, uploadVideo, createExternalVideo, deleteVideo } from "../../api/videoApi";
import { getImages, uploadImage, createExternalImage, deleteImage } from "../../api/imageApi";
import { getPdfs, uploadPdf, createExternalPdf, deletePdf } from "../../api/pdfApi";

const AdminPublications = () => {
  const [media, setMedia] = useState({ videos: [], images: [], pdfs: [] });
  const [loading, setLoading] = useState(true);
  const [newMedia, setNewMedia] = useState({ title: "", url: "", file: null, isExternal: false, date: "" });
  const category = "Publications";
  const navigate = useNavigate();

  // useEffect BEFORE sorting pdf functionality
  // useEffect(() => {
  //   const fetchMedia = async () => {
  //     try {
  //       const videos = await getVideos(category);
  //       const images = await getImages(category);
  //       const pdfs = await getPdfs(category);
  //       setMedia({ videos, images, pdfs });
  //     } catch (error) {
  //       console.error("Error fetching media:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchMedia();
  // }, []);

  // useEffect AFTER sorting pdf functionality
  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const videos = await getVideos(category);
        const images = await getImages(category);
        const pdfs = await getPdfs(category);
        console.log("📄 Debugging PDFs:", pdfs); // ✅ Log the response

        const sortedPdfs = pdfs.sort((a, b) => new Date(b.date) - new Date(a.Date));

        setMedia({ videos, images, pdfs: sortedPdfs });
      } catch (error) {
        console.error("Error fetching media:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, []);


  // handleCreate BEFORE sorting pdf functionality
  // const handleCreate = async (type) => {
  //   try {
  //     console.log(`🟢 handleCreate called - Type: ${type}`);

  //     let createdItem;

  //     if (newMedia.isExternal) {
  //       const data = { url: newMedia.url, title: newMedia.title, category };
  //       if (type === "videos") createdItem = await createExternalVideo(data);
  //       if (type === "images") createdItem = await createExternalImage(data);
  //       if (type === "pdfs") createdItem = await createExternalPdf(data);
  //     } else {
  //       if (!newMedia.file) {
  //         alert("Please select a file before uploading.");
  //         return;
  //       }

  //       const formData = new FormData();
  //       if (type === "pdfs") {
  //         formData.append("pdfFile", newMedia.file);
  //       } else {
  //         formData.append(type.slice(0, -1), newMedia.file);
  //       }
  //       formData.append("title", newMedia.title);
  //       formData.append("category", category);

  //       if (type === "videos") createdItem = await uploadVideo(formData, category);
  //       if (type === "images") createdItem = await uploadImage(formData, category);
  //       if (type === "pdfs") createdItem = await uploadPdf(formData, category);
  //     }

  //     if (createdItem) {
  //       setMedia((prev) => ({
  //         ...prev,
  //         [type]: [...prev[type], createdItem],
  //       }));

  //       if (type === "pdfs") {
  //         const updatedPdfs = await getPdfs(category);
  //         setMedia((prev) => ({
  //           ...prev,
  //           pdfs: updatedPdfs,
  //         }));
  //       }
  //     }
  //   } catch (error) {
  //     console.error("❌ Error creating media:", error);
  //   }
  // };

  //handleCreate AFTER PDF sorting funcitaonlity
  const handleCreate = async (type) => {
    try {
      console.log(`🟢 handleCreate called - Type: ${type}`);

      let createdItem;

      if (newMedia.isExternal) {
        const data = { url: newMedia.url, title: newMedia.title, category, date: newMedia.date };
        if (type === "videos") createdItem = await createExternalVideo(data);
        if (type === "images") createdItem = await createExternalImage(data);
        if (type === "pdfs") createdItem = await createExternalPdf(data);

        if (createdItem && type === "pdfs") {
          console.log("✅ Created External PDF:", createdItem);
  
          // ✅ Manually add external PDF to state immediately
          setMedia((prev) => ({
            ...prev,
            pdfs: [...prev.pdfs, createdItem].sort((a, b) => new Date(b.date) - new Date(a.date)), // ✅ Sort PDFs immediately
          }));
        }

        // 🔄 **Force component re-fetch to ensure UI updates**
        const updatedPdfs = await getPdfs(category);
        setMedia((prev) => ({
          ...prev,
          pdfs: updatedPdfs.sort((a, b) => new Date(b.date) - new Date(a.date)), // ✅ Ensures sorting
        }));
      

      } else {
        if (!newMedia.file || !newMedia.date) {
          alert("Please select a file before uploading.");
          return;
        }

        const formData = new FormData();
        if (type === "pdfs") {
          formData.append("pdfFile", newMedia.file);
        } else {
          formData.append(type.slice(0, -1), newMedia.file);
        }
        formData.append("title", newMedia.title);
        formData.append("date", newMedia.date);
        formData.append("category", category);

        if (type === "videos") createdItem = await uploadVideo(formData, category);
        if (type === "images") createdItem = await uploadImage(formData, category);
        if (type === "pdfs") createdItem = await uploadPdf(formData, category, newMedia.date);
      }

      if (createdItem) {
        setMedia((prev) => ({
          ...prev,
          [type]: [...prev[type], createdItem],
        }));

        if (type === "pdfs") {
          const updatedPdfs = await getPdfs(category);

          setMedia((prev) => ({
            ...prev,
            pdfs: updatedPdfs.sort((a, b) => new Date(b.date) - new Date(a.date)), // ✅ Ensures sorting
          }));
        }
      }
    } catch (error) {
      console.error("❌ Error creating media:", error);
    }
  };
  

  const handleDelete = async (id, type) => {
    try {
      if (type === "videos") await deleteVideo(id);
      if (type === "images") await deleteImage(id);
      if (type === "pdfs") await deletePdf(id);
      setMedia((prev) => ({ ...prev, [type]: prev[type].filter((item) => item._id !== id) }));
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container mx-auto p-6">
      {/* Back Button */}
      <button
        onClick={() => navigate("/admin")}
        className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
      >
        ← Back to Dashboard
      </button>
      <h1 className="text-3xl font-bold mb-6">Admin - Publications</h1>

      {/* Upload Media */}
      <div className="mb-6">
        <input type="text" placeholder="Title" value={newMedia.title} onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })} className="border rounded p-2 w-full mb-2" />
        {/* Date Input Field */}
        <input
          type="date"
          value={newMedia.date}
          onChange={(e) => setNewMedia({ ...newMedia, date: e.target.value })}
          className="border rounded p-2 w-full mb-2"
        />

        <label className="mr-4">
          <input type="radio" name="uploadType" checked={!newMedia.isExternal} onChange={() => setNewMedia({ ...newMedia, isExternal: false, url: "" })} /> Upload File
        </label>
        <label>
          <input type="radio" name="uploadType" checked={newMedia.isExternal} onChange={() => setNewMedia({ ...newMedia, isExternal: true, file: null })} /> External URL
        </label>


        {newMedia.isExternal ? (
          <input type="text" placeholder="External URL" value={newMedia.url} onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value, file: null })} className="border rounded p-2 w-full mb-2" />
        ) : (
          <input type="file" onChange={(e) => setNewMedia((prev) => ({ ...prev, file: e.target.files[0] }))} className="border rounded p-2 w-full mb-2" />
        )}

        <div className="flex gap-2">
          {/* <button onClick={() => handleCreate("videos")} className="bg-blue-500 text-white px-4 py-2 rounded">Add Video</button>
          <button onClick={() => handleCreate("images")} className="bg-green-500 text-white px-4 py-2 rounded">Add Image</button> */}
          <button onClick={() => handleCreate("pdfs")} className="bg-purple-500 text-white px-4 py-2 rounded">Add PDF</button>
        </div>
      </div>

      {/* Display Media BEFORE changing to just display pdfs and to display the chronologically */}
      {/* {["videos", "images", "pdfs"].map((type) => (
        <div key={type} className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{type.charAt(0).toUpperCase() + type.slice(1)}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {media[type]?.map((item) => (
              <div key={item._id} className="border p-4 rounded shadow-md">
                <h3 className="text-lg font-semibold">{item.title}</h3>

                {type === "videos" && (
                  <video className="w-full mt-2 rounded" controls>
                    <source src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} type="video/mp4" />
                  </video>
                )}

                {type === "images" && (
                  <img className="w-full mt-2 rounded" src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} alt={item.title} />
                )}

                {type === "pdfs" && (
                  <button onClick={() => window.open(item.fileUrl || item.url, "_blank")} className="text-blue-500 hover:underline">
                    {item.title || "View PDF"}
                  </button>
                )}

                <button className="bg-red-500 text-white p-2 rounded mt-2" onClick={() => handleDelete(item._id, type)}>Delete</button>
              </div>
            ))}
          </div>
        </div>
      ))} */}
      {/* Display Media AFTER changing to just display pdfs and to display them chronologically*/}
      {["videos", "images", "pdfs"].map((type) => (
        <div key={type} className="mb-6">
          {/* Keep Section Headings */}
          <h2 className="text-2xl font-semibold mb-4">
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </h2>

          {/* ✅ Render PDFs as a Vertical List (Newest First) */}
          {type === "pdfs" ? (
            <div className="flex flex-col gap-2">
              {media.pdfs.length > 0 ? (
                media.pdfs.map((pdf) => (
                  <div key={pdf._id} className="flex justify-between items-center border-b py-2">
                    {/* <a href={pdf.fileUrl || pdf.url} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
                      {pdf.title || "View PDF"}
                    </a> */}
                    <a href={pdf.pdfUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
  {pdf.title || "View PDF"}
</a>

                    <button
                      className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 transition duration-200"
                      onClick={() => handleDelete(pdf._id, "pdfs")}
                    >
                      Delete
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-gray-500 italic">No publications available.</p>
              )}
            </div>
          ) : (
            /* ✅ Comment Out Videos & Images for Future Use */
            /* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {media[type]?.map((item) => (
                <div key={item._id} className="border p-4 rounded shadow-md">
                  <h3 className="text-lg font-semibold">{item.title}</h3>
      
                  {type === "videos" && (
                    <video className="w-full mt-2 rounded" controls>
                      <source src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} type="video/mp4" />
                    </video>
                  )}
      
                  {type === "images" && (
                    <img className="w-full mt-2 rounded" src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} alt={item.title} />
                  )}
      
                  <button className="bg-red-500 text-white p-2 rounded mt-2" onClick={() => handleDelete(item._id, type)}>Delete</button>
                </div>
              ))}
            </div> */
            <></> // Empty fragment to keep JSX valid
          )}
        </div>
      ))}


    </div>
  );
};

export default AdminPublications;








// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { getVideos, uploadVideo, createExternalVideo, deleteVideo } from "../../api/videoApi";
// import { getImages, uploadImage, createExternalImage, deleteImage } from "../../api/imageApi";
// import { getPdfs, uploadPdf, createExternalPdf, deletePdf } from "../../api/pdfApi";

// const AdminPublications = () => {
//   const [media, setMedia] = useState({ videos: [], images: [], pdfs: [] });
//   const [loading, setLoading] = useState(true);
//   const [newMedia, setNewMedia] = useState({ title: "", url: "", file: null, isExternal: false, date: "" });
//   const category = "Publications";
//   const navigate = useNavigate();

//   // useEffect BEFORE sorting pdf functionality
//   // useEffect(() => {
//   //   const fetchMedia = async () => {
//   //     try {
//   //       const videos = await getVideos(category);
//   //       const images = await getImages(category);
//   //       const pdfs = await getPdfs(category);
//   //       setMedia({ videos, images, pdfs });
//   //     } catch (error) {
//   //       console.error("Error fetching media:", error);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };
//   //   fetchMedia();
//   // }, []);

//   // useEffect AFTER sorting pdf functionality
//   useEffect(() => {
//     const fetchMedia = async () => {
//       try {
//         const videos = await getVideos(category);
//         const images = await getImages(category);
//         const pdfs = await getPdfs(category);
//         console.log("📄 Debugging PDFs:", pdfs); // ✅ Log the response

//         const sortedPdfs = pdfs.sort((a, b) => new Date(b.date) - new Date(a.Date));

//         setMedia({ videos, images, pdfs: sortedPdfs });
//       } catch (error) {
//         console.error("Error fetching media:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchMedia();
//   }, []);


//   // handleCreate BEFORE sorting pdf functionality
//   // const handleCreate = async (type) => {
//   //   try {
//   //     console.log(`🟢 handleCreate called - Type: ${type}`);

//   //     let createdItem;

//   //     if (newMedia.isExternal) {
//   //       const data = { url: newMedia.url, title: newMedia.title, category };
//   //       if (type === "videos") createdItem = await createExternalVideo(data);
//   //       if (type === "images") createdItem = await createExternalImage(data);
//   //       if (type === "pdfs") createdItem = await createExternalPdf(data);
//   //     } else {
//   //       if (!newMedia.file) {
//   //         alert("Please select a file before uploading.");
//   //         return;
//   //       }

//   //       const formData = new FormData();
//   //       if (type === "pdfs") {
//   //         formData.append("pdfFile", newMedia.file);
//   //       } else {
//   //         formData.append(type.slice(0, -1), newMedia.file);
//   //       }
//   //       formData.append("title", newMedia.title);
//   //       formData.append("category", category);

//   //       if (type === "videos") createdItem = await uploadVideo(formData, category);
//   //       if (type === "images") createdItem = await uploadImage(formData, category);
//   //       if (type === "pdfs") createdItem = await uploadPdf(formData, category);
//   //     }

//   //     if (createdItem) {
//   //       setMedia((prev) => ({
//   //         ...prev,
//   //         [type]: [...prev[type], createdItem],
//   //       }));

//   //       if (type === "pdfs") {
//   //         const updatedPdfs = await getPdfs(category);
//   //         setMedia((prev) => ({
//   //           ...prev,
//   //           pdfs: updatedPdfs,
//   //         }));
//   //       }
//   //     }
//   //   } catch (error) {
//   //     console.error("❌ Error creating media:", error);
//   //   }
//   // };

//   //handleCreate AFTER PDF sorting funcitaonlity BEFORE adding title without pdf
//   const handleCreate = async (type) => {
//     try {
//       console.log(`🟢 handleCreate called - Type: ${type}`);

//       let createdItem;

//       if (newMedia.isExternal) {
//         const data = { url: newMedia.url, title: newMedia.title, category, date: newMedia.date };
//         if (type === "videos") createdItem = await createExternalVideo(data);
//         if (type === "images") createdItem = await createExternalImage(data);
//         if (type === "pdfs") createdItem = await createExternalPdf(data);

//         if (createdItem && type === "pdfs") {
//           console.log("✅ Created External PDF:", createdItem);

//           //Manually add external PDF to state immediately
//           setMedia((prev) => ({
//             ...prev,
//             pdfs: [...prev.pdfs, createdItem].sort((a, b) => new Date(b.date) - new Date(a.date)), //Sort PDFs immediately
//           }));
//         }

//         //Force component re-fetch to ensure UI updates
//         const updatedPdfs = await getPdfs(category);
//         setMedia((prev) => ({
//           ...prev,
//           pdfs: updatedPdfs.sort((a, b) => new Date(b.date) - new Date(a.date)), //Ensures sorting
//         }));


//       // } else {
//       //   if (!newMedia.file || !newMedia.date) {
//       //     alert("Please select a file before uploading.");
//       //     return;
//       //   }

//     } else {
//       // If no file is selected, ensure date is included and proceed
//       if (!newMedia.date) {
//         alert("Please add a date before uploading.");
//         return;
//       }

//         const formData = new FormData();
//         // if (type === "pdfs") {
//         //   formData.append("pdfFile", newMedia.file);
//         // } else {
//         //   formData.append(type.slice(0, -1), newMedia.file);
//         // }


//       // formData.append("title", newMedia.title);
//       // formData.append("date", newMedia.date);
//       // formData.append("category", category);

//         // If the file exists, append it
//         if (newMedia.file) {
//           if (type === "pdfs") {
//             formData.append("pdfFile", newMedia.file);
//           } else {
//             formData.append(type.slice(0, -1), newMedia.file);
//           }
//         }

//         // If editing an existing PDF, send the PDF ID *** code BEFORE the adding title without pdf funcitoanlity
//         //  if (newMedia.pdfId) {
//         //   formData.append("pdfId", newMedia.pdfId);  // When editing, include the pdfId
//         // }

//         formData.append("title", newMedia.title);
//         formData.append("date", newMedia.date);
//         formData.append("category", category);

//         if (type === "videos") createdItem = await uploadVideo(formData, category);
//         if (type === "images") createdItem = await uploadImage(formData, category);
//         if (type === "pdfs") createdItem = await uploadPdf(formData, category, newMedia.date);
//       }

//       if (createdItem) {
//         setMedia((prev) => ({
//           ...prev,
//           [type]: [...prev[type], createdItem],
//         }));

//         if (type === "pdfs") {
//           const updatedPdfs = await getPdfs(category);

//           setMedia((prev) => ({
//             ...prev,
//             pdfs: updatedPdfs.sort((a, b) => new Date(b.date) - new Date(a.date)), // ✅ Ensures sorting
//           }));
//         }
//       }
//     } catch (error) {
//       console.error("❌ Error creating media:", error);
//     }
//   };




//   const handleEdit = (pdfId) => {
//     const pdfToEdit = media.pdfs.find((pdf) => pdf._id === pdfId);
//     setNewMedia({
//       ...newMedia,
//       title: pdfToEdit.title,
//       pdfId: pdfToEdit._id,
//       file: null, // Reset the file field since we're only editing the title
//     });
//   };



//   const handleDelete = async (id, type) => {
//     try {
//       if (type === "videos") await deleteVideo(id);
//       if (type === "images") await deleteImage(id);
//       if (type === "pdfs") await deletePdf(id);
//       setMedia((prev) => ({ ...prev, [type]: prev[type].filter((item) => item._id !== id) }));
//     } catch (error) {
//       console.error("Error deleting:", error);
//     }
//   };


//   if (loading) return <p>Loading...</p>;

//   return (
//     <div className="container mx-auto p-6">
//       {/* Back Button */}
//       <button
//         onClick={() => navigate("/admin")}
//         className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
//       >
//         ← Back to Dashboard
//       </button>
//       <h1 className="text-3xl font-bold mb-6">Admin - Publications</h1>

//       {/* Upload or Edit Media */}
//       <div className="mb-6">
//         <input
//           type="text"
//           placeholder="Title"
//           value={newMedia.title}
//           onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
//           className="border rounded p-2 w-full mb-2" />
//         {/* Date Input Field */}
//         <input
//           type="date"
//           value={newMedia.date}
//           onChange={(e) => setNewMedia({ ...newMedia, date: e.target.value })}
//           className="border rounded p-2 w-full mb-2"
//         />
//         <label className="mr-4">
//           <input
//             type="radio"
//             name="uploadType"
//             checked={!newMedia.isExternal}
//             onChange={() => setNewMedia({ ...newMedia, isExternal: false, url: "" })} />{" "}
//           Upload File
//         </label>
//         <label>
//           <input
//             type="radio"
//             name="uploadType"
//             checked={newMedia.isExternal}
//             onChange={() => setNewMedia({ ...newMedia, isExternal: true, file: null })} />{" "}
//           External URL
//         </label>

//         {/* {newMedia.isExternal ? (
//           <input
//             type="text"
//             placeholder="External URL"
//             value={newMedia.url}
//             onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value, file: null })}
//             className="border rounded p-2 w-full mb-2" />
//         ) : (
//           <input type="file" onChange={(e) => setNewMedia((prev) => ({ ...prev, file: e.target.files[0] }))} className="border rounded p-2 w-full mb-2" />
//         )} */}
//         {newMedia.isExternal ? (
//         <input
//           type="text"
//           placeholder="External URL"
//           value={newMedia.url}
//           onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value, file: null })}
//           className="border rounded p-2 w-full mb-2"
//         />
//       ) : (
//         <>
//           <input
//             type="file"
//             onChange={(e) => setNewMedia((prev) => ({ ...prev, file: e.target.files[0] }))}
//             className="border rounded p-2 w-full mb-2"
//           />
//         </>
//       )}



//         {/* <div className="flex gap-2">
//           <button onClick={() => handleCreate("pdfs")} className="bg-purple-500 text-white px-4 py-2 rounded">Add PDF</button>
//         </div>
//       </div> */}

//         {/* Conditionally render the button based on the presence of pdfId */}
//         {newMedia.pdfId ? (
//         <button
//           onClick={() => handleCreate("pdfs")}
//           className="bg-blue-500 text-white px-4 py-2 rounded"
//         >
//           Update PDF
//         </button>
//       ) : (
//         <button
//           onClick={() => handleCreate("pdfs")}
//           className="bg-purple-500 text-white px-4 py-2 rounded"
//         >
//           Add PDF
//         </button>
//       )}


//       </div>

//       {/* Display Media BEFORE changes to pdfs to allow for pdf not to be included during create */}
//       {/* {["videos", "images", "pdfs"].map((type) => (
//         <div key={type} className="mb-6">
//           <h2 className="text-2xl font-semibold mb-4">
//             {type.charAt(0).toUpperCase() + type.slice(1)}
//           </h2>

//           {type === "pdfs" ? (
//             <div className="flex flex-col gap-2">
//               {media.pdfs.length > 0 ? (
//                 media.pdfs.map((pdf) => (
//                   <div key={pdf._id} className="flex justify-between items-center border-b py-2">
//                     <a href={pdf.pdfUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">
//                       {pdf.title || "View PDF"}
//                     </a>
//                     <button
//                       className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600 transition duration-200"
//                       onClick={() => handleDelete(pdf._id, "pdfs")}
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 ))
//               ) : (
//                 <p className="text-gray-500 italic">No publications available.</p>
//               )}
//             </div>
//           ) : (          
//             <></>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// }; */}

// {/* Display Media */}
// {["videos", "images", "pdfs"].map((type) => (
//         <div key={type} className="mb-6">
//           {/* Section Heading */}
//           <h2 className="text-2xl font-semibold mb-4">
//             {type.charAt(0).toUpperCase() + type.slice(1)}
//           </h2>

//           {/* Render Media Items */}
//           {media[type]?.length > 0 ? (
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//               {media[type].map((item) => (
//                 <div key={item._id} className="border p-4 rounded shadow-md">
//                   <h3 className="text-lg font-semibold">{item.title}</h3>

//                   {/* {type === "videos" && item.fileUrl && (
//                     <video className="w-full mt-2 rounded" controls>
//                       <source
//                         src={`http://localhost:5555${item.fileUrl}`}
//                         type="video/mp4"
//                       />
//                     </video>
//                   )}

//                   {type === "images" && item.fileUrl && (
//                     <img
//                       className="w-full mt-2 rounded"
//                       src={`http://localhost:5555${item.fileUrl}`}
//                       alt={item.title}
//                     />
//                   )} */}

//                   {type === "pdfs" && item.pdfUrl && (
//                     <a
//                       href={item.pdfUrl}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-blue-500 hover:underline"
//                     >
//                       {item.title || "View PDF"}
//                     </a>
//                   )}

//                   <div className="flex gap-2 mt-2">
//                     <button
//                       onClick={() => {
//                         setNewMedia({
//                           title: item.title,
//                           date: item.date,
//                           isExternal: false,
//                           url: "",
//                           file: null,
//                           pdfId: item._id,
//                         });
//                       }}
//                       className="bg-yellow-500 text-white px-4 py-2 rounded"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(item._id, type)}
//                       className="bg-red-500 text-white px-4 py-2 rounded"
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p className="text-gray-500 italic">No {type} available.</p>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };


// export default AdminPublications;


{/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {media[type]?.map((item) => (
                <div key={item._id} className="border p-4 rounded shadow-md">
                  <h3 className="text-lg font-semibold">{item.title}</h3>
      
                  {type === "videos" && (
                    <video className="w-full mt-2 rounded" controls>
                      <source src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} type="video/mp4" />
                    </video>
                  )}
      
                  {type === "images" && (
                    <img className="w-full mt-2 rounded" src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} alt={item.title} />
                  )}
      
                  <button className="bg-red-500 text-white p-2 rounded mt-2" onClick={() => handleDelete(item._id, type)}>Delete</button>
                </div>
              ))}
            </div> */}